import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import Map from "../map";
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner-transparent.gif";
import flatpickr from "flatpickr";


class MapDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDateFilter: false,
      date_from: "",
      date_to: ""
    }
    this.dateInputRef = React.createRef();
    this.applyDateFilter = this.applyDateFilter.bind(this)
    this.toggleDateFilter = this.toggleDateFilter.bind(this)
    this.resetDateFilter = this.resetDateFilter.bind(this)
  }

  componentDidUpdate(_, prevState) {
    if (!prevState.showDateFilter && this.state.showDateFilter) {
      this.fp = flatpickr(this.dateInputRef.current, {
        mode: "range",
        dateFormat: "Y-m-d",
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            const date_from = selectedDates[0].toISOString().split("T")[0]
            const date_to = selectedDates[1].toISOString().split("T")[0]
            this.setState({ date_from, date_to })
          }
        }
      })
    }

    if (prevState.showDateFilter && !this.state.showDateFilter && this.fp) {
      this.fp.destroy()
      this.fp = null
    }
  }

  componentWillUnmount() {
    if (this.fp) {
      this.fp.destroy()
    }
  }

  toggleDateFilter() {
    this.setState({ showDateFilter: !this.state.showDateFilter, date_from: "", date_to: "" })
  }

  applyDateFilter() {
    if (this.state.date_from && this.state.date_to) {
      this.setState({ dateFilterApplied: true })
      this.props.getDateFilteredResults(this.state.date_from, this.state.date_to)
    }
  }

  resetDateFilter() {
    this.setState({ dateFilterApplied: false, showDateFilter: false, date_from: "", date_to: "" })
    this.props.getFullResults()
  }

  render() {
    return (
      <div className="mapDashboardDiv">
        <div className="mapDashboardcontents">
          <div className="dashboardCategoryHeading">Properties Map</div>
          <div className="dashboardCategorySubheading">This is an overview map of your recent photoshoots</div>
          <div className="mapDashboardControls">
            {this.state.dateFilterApplied ? <div className="viewAllProjectsMap"
              onClick={this.resetDateFilter}>View All Photoshoots
            </div> : !this.props.full_map_results ? <div className="viewAllProjectsMap"
              onClick={this.props.getFullResults}>View All Photoshoots
            </div> : <div></div>}
            <div className="mapDateFilterButton" onClick={this.toggleDateFilter}>
              Filter by Date
            </div>
          </div>
          {this.state.showDateFilter && (
            <div className="mapDateFilterRow">
              <input
                ref={this.dateInputRef}
                type="text"
                className="mapDateFilterInput"
                placeholder="Select date range..."
                readOnly
              />
              <div
                className={`mapDateFilterApply${!this.state.date_from ? ' mapDateFilterApplyDisabled' : ''}`}
                onClick={this.applyDateFilter}
              >
                Apply
              </div>
            </div>
          )}
          <Map projects={this.props.projects} full_map_results={this.props.full_map_results}/>
        </div>
      </div>
    );
  }
}

export default withRouter(MapDashboard)
